<template>
	<div
		v-if="type == 'sale'"
		class="absolute bottom-2 w-10 h-7 bg-redcustom text-white text-xs flex items-center justify-center"
	>
		<span>{{ $t("Sale") }}</span>
	</div>

	<div
		v-if="type == 'campaign'"
		class="absolute bottom-2 w-10 h-7 bg-campaign text-white text-xs flex items-center justify-center"
	>
		<span>{{ $t("Campaign") }}</span>
	</div>
	<div
		v-if="type == 'new'"
		class="absolute bottom-11 w-10 h-7 bg-new-product text-white text-xs flex items-center justify-center"
	>
		<span>{{ $t("New") }}</span>
	</div>
</template>

<script setup lang="ts">
interface Props {
	type: string;
}
const { type } = defineProps<Props>();
</script>
